<template>
  <el-dialog title="配置" :visible.sync = "waterDialog" width="650px" :close-on-click-modal='false' :show-close="true" :before-close="closeDialog">
      <el-form class="global-form2" :model="formInfo" :rules="rules" ref="formInfo" label-width="200px">
        <el-form-item label="设备名称">
          <el-input type="text" v-model="formInfo.deviceName" placeholder="请输入设备名称" maxlength="20" show-word-limit/>
        </el-form-item>
        <el-form-item label="设备串号">
          <el-input type="text" v-model="formInfo.deviceNumber" placeholder="请输入设备串号" disabled/>
        </el-form-item>
        <el-form-item prop="pressureUpThreshold" label="压力告警高值(Mpa)">
          <el-input type="text" maxlength="10" show-word-limit v-model="formInfo.pressureUpThreshold" placeholder="请输入压力告警高值(参考数值：0.5)"/>
        </el-form-item>
        <el-form-item prop="pressureThreshold" label="压力告警低值(Mpa)">
          <el-input type="text" maxlength="10" show-word-limit v-model="formInfo.pressureThreshold" placeholder="请输入压力告警低值(参考数值：0.01)"/>
        </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
            <el-button @click="closeDialog">取消</el-button>
          </el-form-item>
      </el-form>
  </el-dialog>
</template>

<script>
const threeDecimal = (rule, value, callback) => {
const reg = /^([1-9][0-9]*|[0-9])(\.\d{0,3})?$/
  if (value && !reg.test(value)) {
    return callback(new Error('请输入非负数的数字,最多保留三位小数'))
  } else {
    return callback()
  }
}

export default {
  name: 'SoilDialog',
  props: {
    waterDialog: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Object,
      default: () => {
        return  { deviceNumber: '' }
      }
    }
  },
  data () {
    return {
      formInfo: {},
      rules: {
        pressureThreshold: [
          { required: true, message: '请输入压力告警低值', trigger: 'blur' },
          { validator: threeDecimal, trigger: 'blur' }
        ],
        pressureUpThreshold: [
          { required: true, message: '请输入压力告警高值', trigger: 'blur' },
          { validator: threeDecimal, trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    waterDialog () {
      // 1
      this.formInfo = JSON.parse(JSON.stringify(this.detail))
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    onSubmit () {
      this.$refs.formInfo.validate((valid) => {
        if (valid) {
          if (this.detail.pressureUpThreshold <= this.detail.pressureThreshold) {
            this.$message.warning('压力告警高值必须大于压力告警低值')
            return false
          }
          if (this.detail.deviceNumber) {
            this.formInfo = { ...this.formInfo, deviceNumber: [this.detail.deviceNumber] }
          }
          this.$axios.post(this.$apis.iot.updateJgWaterLyInfoThreshold, {
            deviceNumber: this.formInfo.deviceNumber[0],
            pressureThreshold: this.formInfo.pressureThreshold,
            pressureUpThreshold: this.formInfo.pressureUpThreshold,
            deviceName: this.formInfo.deviceName
          }).then((res) => {
            this.$message.success('设置成功')
            this.$emit('success')
            this.closeDialog()
          })
        }
      })
    },
    closeDialog () {
      this.$emit('update:waterDialog', false)
    }
  }
}
</script>
